import { render, staticRenderFns } from "./channels.vue?vue&type=template&id=6555c0c0&scoped=true"
import script from "./channels.vue?vue&type=script&lang=ts"
export * from "./channels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6555c0c0",
  null
  
)

export default component.exports